import { systemIsHour12 as is12HourClock } from '@/utils/intl';

// en-US: Sunday, October 25, 2020, 3:50:50 PM
// fr-FR: dimanche 25 octobre 2020 à 15:50:50
// de-CH: Sonntag, 25. Oktober 2020, 15:50:50
export const fullDateAndTime = {
  hour12: is12HourClock,
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
};

// en-US: oct 15
// fr-FR: 15 oct.
// de-CH: 15. oct
export const monthAndDay = {
  hour12: is12HourClock,
  month: 'short',
  day: 'numeric',
};

// en-US: 02:30 PM
// fr-FR: 14:30
// de-CH: 14:30
export const time = {
  hour12: is12HourClock,
  hour: '2-digit',
  minute: '2-digit',
};

// en-US: sun
// fr-FR: dim.
// de-CH: so
export const weekDay = {
  hour12: is12HourClock,
  weekday: 'short',
};
